"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebComponent = void 0;
var react_1 = __importDefault(require("react"));
var pds = powerSchoolDesignSystemToolkit;
var isPdsTag = /^pds-/;
var log = pds.logger.requiresLogger('react-web-component');
var WebComponent = (function (_super) {
    __extends(WebComponent, _super);
    function WebComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isComponentMounted: false,
            isPolymerComponentRegisered: false
        };
        _this.elementRef = react_1.default.createRef();
        if (isPdsTag.test(props.tag)) {
            pds.polymerUtils.awaitComponentsRegistered(pds.polymerUtils.getWidgetDependencies(props.tag).concat([props.tag])).subscribe(function () {
                if (_this.state.isComponentMounted) {
                    log('setting state using setState method');
                    _this.setState({ isPolymerComponentRegisered: true });
                }
                else {
                    log('setting state directly');
                    _this.state.isPolymerComponentRegisered = true;
                }
            });
        }
        else {
            _this.state.isPolymerComponentRegisered = true;
        }
        return _this;
    }
    WebComponent.prototype.componentDidUpdate = function (previousProps) {
        this.updateProps();
        this.updateAttrs(previousProps.attributes);
        this.updateListeners(previousProps.listeners);
    };
    WebComponent.prototype.componentDidMount = function () {
        this.updateProps();
        this.updateAttrs();
        this.updateListeners();
        this.setState({ isComponentMounted: true });
    };
    WebComponent.prototype.componentWillUnmount = function () {
        var element = this.elementRef.current;
        for (var listenerName in this.props.listeners) {
            var oldListenerFunction = this.props.listeners[listenerName];
            if (element != null) {
                element.removeEventListener(listenerName, oldListenerFunction);
            }
        }
    };
    WebComponent.prototype.updateProps = function () {
        var element = this.elementRef.current;
        if (element == null) {
            return;
        }
        for (var prop in this.props.properties) {
            element[prop] = this.props.properties[prop];
        }
    };
    WebComponent.prototype.updateAttrs = function (previousAttributes) {
        var element = this.elementRef.current;
        if (element == null) {
            return;
        }
        if (previousAttributes != null) {
            var currentAttributeList = this.props.attributes;
            for (var previousAttribute in previousAttributes) {
                if (previousAttribute !== 'class') {
                    var currentAttributeValue = currentAttributeList[previousAttribute];
                    if (currentAttributeValue == null || currentAttributeValue === '') {
                        element.removeAttribute(previousAttribute);
                    }
                }
            }
            if (previousAttributes['class'] != null) {
                var oldClassList = previousAttributes.class.split(' ');
                for (var _i = 0, oldClassList_1 = oldClassList; _i < oldClassList_1.length; _i++) {
                    var className = oldClassList_1[_i];
                    element.classList.remove(className);
                }
            }
        }
        for (var attr in this.props.attributes) {
            var attributeToSet = this.props.attributes[attr];
            if (attr !== 'class' && attributeToSet != null) {
                element.setAttribute(attr, attributeToSet);
            }
        }
        if (this.props.attributes != null && this.props.attributes.class != null) {
            var classList = this.props.attributes.class.split(' ');
            for (var _a = 0, classList_1 = classList; _a < classList_1.length; _a++) {
                var className = classList_1[_a];
                element.classList.add(className);
            }
        }
    };
    WebComponent.prototype.updateListeners = function (previousListeners) {
        var element = this.elementRef.current;
        if (element == null) {
            return;
        }
        if (previousListeners != null) {
            for (var listenerName in previousListeners) {
                var oldListenerFunction = previousListeners[listenerName];
                element.removeEventListener(listenerName, oldListenerFunction);
            }
        }
        for (var listenerName in this.props.listeners) {
            var listenerFunction = this.props.listeners[listenerName];
            element.addEventListener(listenerName, listenerFunction);
        }
    };
    WebComponent.prototype.render = function () {
        var PdsTag = this.props.tag;
        if (this.state.isPolymerComponentRegisered) {
            return react_1.default.createElement(PdsTag, { ref: this.elementRef }, this.props.children);
        }
        else {
            return '';
        }
    };
    return WebComponent;
}(react_1.default.Component));
exports.WebComponent = WebComponent;

//# sourceMappingURL=web-component.js.map
